import { EcoScoreApi, EcoScoreRecommendation } from '@clients/myTrips' // eslint-disable-line no-unused-vars
import appendCredentials from '@util/appendCredentials'
import getBasePath from '@util/path'
import { AxiosPromise } from 'axios' // eslint-disable-line no-unused-vars

let basePath = getBasePath() + '/my-trips'

export default class ExtendedEcoScoreApi extends EcoScoreApi {
  getEcoScoreRecommendation (tripId: number, options?: any): AxiosPromise<EcoScoreRecommendation> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getEcoScoreRecommendation(tripId, undefined, optionsParam)
  }
}
